<template>
  <div class="home-page">
    <div class="swiper" style="overflow: hidden;" :style="{height: windowHeight + 'px'}">
      <div class="swiper-topnav flex-center position-relative">
        <img class="position-absolute swiper-topnav-logo" src="@/assets/shjk/icon-web-logo.png">
        <div class="swiper-topnav-text flex">
          <p v-for="(item, index) in navMenu" :key="index" class="font-14 cursor" :class="currIndex==item.index?'active':''" @click="menuTap(index)">{{ item.name }}</p>
        </div>
        <div class="swiper-topnav-btn flex-row-center position-absolute">
          <div class="swiper-topnav-btn-input flex-row-center" :class="showSearch?'show':'hide'">
            <el-input ref="saveTagInput" v-model="searchKey" placeholder="请输入内容" size="normal" @keyup.enter.native="inputChange" @blur="showSearch=false" />
            <img class="" src="@/assets/shjk/icon-web-search-in.png">
          </div>
          <img class="flex-shrink cursor" src="@/assets/shjk/icon-web-search.png" @click.prevent="totalSearch">
        </div>
      </div>
      <div class="swiper-wrapper">
        <div class="swiper-slide" :style="{height: windowHeight + 'px'}">
          <div class="swiper-slide-wraper p1">
            <div class="flex-center match-width match-height position-relative" style="padding: 0 60px;">
              <div class="match-width">
                <div class="flex-center">
                  <img src="@/assets/shjk/icon-web-home-tit.png">
                </div>
                <div ref="horSwiper" class="swiper-slide-wraper-horizontal">
                  <div v-if="swiperList.length" class="swiper-wrapper">
                    <div v-for="(item, index) in swiperList" :key="index" class="swiper-slide cursor" :style="{width: swiperItemWidth + 'px !important;'}" @click="toBannerEvent(index)">
                      <div class="swiper-slide-sub-wrap">
                        <p class="date">{{ item.startDate }}</p>
                        <p class="tit text-line-1 flex-shrink">{{ item.name }}</p>
                        <img :src="item.image">
                        <p class="des flex-1 text-line-3">{{ item.description }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-scrollbar">
                  <div class="swiper-scrollbar-drag">
                    <span v-if="horwiper">{{ swiperItemYear }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide" :style="{height: windowHeight + 'px'}">
          <div class="swiper-slide-wraper p2">
            <div v-if="sourceCards.length" class="swiper-slide-wraper-layer flex-center">
              <div v-for="(item, index) in sourceCards" :key="index" class="swiper-slide-wraper-layer-item cursor" @click="toSource(index)">
                <div class="top flex-1 flex-column-center">
                  <div class="img">
                    <img :src="require(`@/assets/shjk/${item.configInfo.img}`)">
                  </div>
                  <p class="tit">{{ item.name }}</p>
                  <p class="desc">{{ item.remark }}</p>
                </div>
                <div class="tail flex-shrink flex-center">
                  <p>{{ item.configInfo.tit }} {{ item.resourceCount || '0' }} {{ item.configInfo.unit }}</p>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="swiper-slide" :style="{height: windowHeight + 'px'}">
          <div class="swiper-slide-wraper p4">
            <div class="swiper-slide-wraper-layer flex-center">
              <div class="swiper-slide-wraper-layer-p4list flex match-width">
                <div v-for="(item,index) in eventCards" :key="index" class="swiper-slide-wraper-layer-p4list-item">
                  <div class="top cursor" @click="toEvent(index)">
                    <el-image class="img" :src="require(`@/assets/shjk/${item.configInfo.img}`)" fit="fill" />
                    <p class="tit">{{ item.name }}</p>
                    <p class="info text-line-2" :title="item.remark">{{ item.remark }}</p>
                  </div>
                  <div class="list">
                    <div v-for="(s, i) in item.list" :key="i" class="item flex-row-center cursor" @click="toRecEntity(item, s)">
                      <el-image class="icon flex-shrink" :src="s.image" fit="fill">
                        <div slot="placeholder" class="image-slot font-12">
                          加载中<span class="dot font-12">...</span>
                        </div>
                      </el-image>
                      <span class="flex-1">
                        <p class="name text-line-1">{{ s.name || '-' }}</p>
                        <p class="des text-line-1">{{ s.description || '-' }}</p>
                      </span>
                    </div>
                  </div>
                  <p class="tail cursor" @click="toEvent(index)">...</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide" :style="{height: windowHeight + 'px'}">
          <div class="swiper-slide-wraper p5">
            <div class="swiper-slide-wraper-layer flex-center">
              <div class="swiper-slide-wraper-layer-p5list flex-center match-width">
                <div v-for="(item,index) in topicCards" :key="index" class="swiper-slide-wraper-layer-p5list-item cursor" @click="toTopic(item)">
                  <el-image :src="item.coverImage" fit="fill" class="img">
                    <div slot="placeholder" class="image-slot">
                      <img class="match-height match-width" src="../../assets/img/icon-default.jpg">
                    </div>
                    <div slot="error" class="image-slot">
                      <img class="match-height match-width" src="../../assets/img/icon-default.jpg">
                    </div>
                  </el-image>
                  <div class="tit">
                    <p>{{ item.title }}</p>
                  </div>
                </div>
                <div v-if="topicCount>4" class="show-more flex-center cursor" @click="toTopic">
                  <p class="font-16 font-color-fff">更多专题</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide swiper-no-swiping" :style="{height: windowHeight + 'px'}">
          <div class="swiper-slide-wraper p6">
            <div class="swiper-slide-wraper-layer flex-center">
              <div class="match-width flex" style="margin-bottom: 20px; height: calc(100% - 320px);">
                <div id="amap-body" class="swiper-slide-wraper-layer-content-map swiper-no-mousewheel flex-1" />
                <div v-if="pointCards.length" class="swiper-slide-wraper-layer-content-list swiper-no-mousewheel flex-shrink swiper-no-mousewheel">
                  <div v-for="(item, index) in pointCards" :key="index" class="swiper-slide-wraper-layer-content-list-item flex-row-center flex cursor" @click="changeMap(index)">
                    <img v-if="index === activeIndex" class="flex-shrink" src="../../assets/shjk/icon-home-map.png">
                    <p v-else class="icon flex-shrink">-</p>
                    <p class="tit flex-1 text-line-1">{{ item.name }}</p>
                    <p class="date flex-shrink">{{ item.createDate }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide last swiper-no-swiping">
          <div class="swiper-slide-wraper">
            <nav-bottom class="nav-bottom position-absolute flex-shrink" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import relationData from './data/relation.json'

import navBottom from '@/components/home-bottom/index'
import api from '@/api/index'
import { getShowPath } from '@/utils/imgpath.js'
import Swiper from 'swiper'
import { Scrollbar, FreeMode, Mousewheel } from 'swiper/modules'
export default {
  components: {
    navBottom
  },
  data() {
    return {
      searchKey: '',
      showSearch: false,
      mapIndex: 0,
      sourceCards: [],
      relationCards: relationData,
      eventCards: [],
      topicCards: [],
      topicCount: 0,
      pointCards: [],
      verwiper: null,
      horwiper: null,
      currIndex: 0,
      navMenu: [{
        name: '首页',
        index: 0
      }, {
        name: '数字资源',
        index: 1
      }, {
        name: '记忆本体',
        index: 2
      }, {
        name: '特色专题',
        index: 3
      }, {
        name: '红色印记',
        index: 4
      }],
      topics: [],
      swiperList: [],
      swiperItemWidth: 260,
      swiperItemTotal: 0,
      swiperItemYear: '',
      windowWidth: window.innerWidth,
      windowHeight: document.documentElement.clientHeight,

      // 地图实例
      map: null,
      // 标记点数组
      markers: [],
      // 轨迹线实例
      polyline: null,
      dynamicPolyline: null, // 动态绘制的轨迹线
      // 轨迹动画点
      animateMarker: null,
      isPlaying: false,
      activeIndex: -1,
      animateTimer: null,
      defaultZoom: 14, // 默认缩放级别
      currentStep: 0, // 当前播放到的地点索引
      currentFrame: 0, // 当前帧（两点间的进度）
      animateSpeed: 30, // 动画速度（ms/步）
      stepCount: 50, // 两点间的步进数（平滑度）
      dynamicPath: [], // 动态轨迹线的路径
      baseStepSpeed: 0.2 // 基础步速（米/秒）
    }
  },
  watch: {
    windowWidth(val) {
      if (window.innerWidth < 1000) {
        this.swiperItemWidth = (window.innerWidth - 120 - 60) / 3 - 40
      } else if (window.innerWidth >= 1000 && window.innerWidth < 1400) {
        this.swiperItemWidth = (window.innerWidth - 120 - 80) / 4 - 40
      } else if (window.innerWidth >= 1400) {
        this.swiperItemWidth = (window.innerWidth - 120 - 100) / 5 - 40
      }
      this.initHorizontalSwiper()
    }
  },
  mounted() {
    if (window.innerWidth < 1000) {
      this.swiperItemWidth = (window.innerWidth - 120 - 60) / 3 - 40
    } else if (window.innerWidth >= 1000 && window.innerWidth < 1400) {
      this.swiperItemWidth = (window.innerWidth - 120 - 80) / 4 - 40
    } else if (window.innerWidth >= 1400) {
      this.swiperItemWidth = (window.innerWidth - 120 - 100) / 5 - 40
    }
    this.currIndex = this.$route.query.key || 0
    const that = this
    this.verwiper = new Swiper('.swiper', {
      modules: [Mousewheel],
      direction: 'vertical',
      autoHeight: true,
      slidesPerView: 'auto',
      speed: 1000,
      mousewheel: true
    })
    this.verwiper.on('slideChange', function() {
      that.currIndex = that.verwiper.realIndex
    })
    if (this.currIndex > 0) {
      setTimeout(() => {
        this.verwiper.slideTo(this.currIndex)
      }, 500)
    }

    this.request()
    this.dictionaryData()

    window.onresize = () => {
      this.windowWidth = document.body.clientWidth
      this.windowHeight = document.documentElement.clientHeight
    }
  },
  methods: {
    async request() {
      const res = await api.eventList({ asc: 1, field: 'startDate', majorEvent: 1, limit: 100, page: 1 })
      if (res.code === 2000) {
        res.items.data.forEach(v => {
          v.image = getShowPath('img', v.image)
          if (v.startDate) {
            v.startDate = v.startDate.split('-')[0]
          }
        })
        this.swiperList = res.items.data
        this.swiperItemTotal = this.swiperItemWidth * this.swiperList.length + this.swiperList.length * 20
        setTimeout(() => {
          this.swiperItemYear = this.swiperList[0].startDate
          this.initHorizontalSwiper()
        }, 1000)
      }

      const r = await api.placeList({ asc: 1, field: 'createDate', limit: 100, page: 1 })
      if (r.code === 2000) {
        const ary = r.items.data.filter(v => v.mapPlace)
        ary.forEach(v => {
          const p = v.mapPlace.split(',')
          v.mapPlace = [parseFloat(p[0]), parseFloat(p[1])]
        })
        this.pointCards = ary
        setTimeout(() => {
          this.loadMap()
        }, 100)
      }

      const catelog = await api.getResourceCatalog()
      if (catelog.code === 2000) {
        catelog.items.forEach(v => {
          v.configInfo = JSON.parse(v.configInfo)
        })
        this.sourceCards = catelog.items
      }
    },
    dictionaryData() {
      api.dictionaryData({ parentId: 1012 }).then(res => {
        if (res.code === 2000) {
          res.items.forEach(v => {
            v.configInfo = JSON.parse(v.configInfo)
          })
          this.eventCards = res.items
          this.requestList()
        }
      })
    },
    requestList() {
      this.eventCards.forEach(item => {
        if (item.code === '013001') {
          api.person({
            catalogId: '013001',
            page: 1,
            limit: 5,
            recommend: 1,
            asc: 0,
            field: 'recommendDate'
          }).then(res => {
            if (res.code === 2000) {
              res.items.data.forEach(value => {
                value.image = getShowPath('img', value.image)
              })
              item.list = res.items.data
            }
          })
        } else if (item.code === '013002') {
          api.place({
            catalogId: '013002',
            page: 1,
            limit: 5,
            recommend: 1,
            asc: 0,
            field: 'recommendDate'
          }).then(res => {
            if (res.code === 2000) {
              res.items.data.forEach(value => {
                value.image = getShowPath('img', value.image)
              })
              item.list = res.items.data
            }
          })
        } else if (item.code === '013004') {
          api.organization({
            catalogId: '013002',
            page: 1,
            limit: 5,
            recommend: 1,
            asc: 0,
            field: 'recommendDate'
          }).then(res => {
            if (res.code === 2000) {
              res.items.data.forEach(value => {
                value.image = getShowPath('img', value.image)
              })
              item.list = res.items.data
            }
          })
        } else if (item.code === '013003') {
          api.event({
            catalogId: '013002',
            page: 1,
            limit: 5,
            recommend: 1,
            asc: 0,
            field: 'recommendDate'
          }).then(res => {
            if (res.code === 2000) {
              res.items.data.forEach(value => {
                value.image = getShowPath('img', value.image)
              })
              item.list = res.items.data
            }
          })
        }
      })

      // api.event({
      //   catalogId: '013003',
      //   page: 1,
      //   limit: 5,
      //   recommend: 1,
      //   asc: 0,
      //   field: 'recommendDate'
      // }).then(res => {
      //   if (res.code === 2000) {
      //     res.items.data.forEach(value => {
      //       value.image = getShowPath('img', value.image)
      //     })
      //     this.eventCards[2].list = res.items.data
      //   }
      // })
      // api.organization({
      //   catalogId: '013004',
      //   page: 1,
      //   limit: 5,
      //   recommend: 1,
      //   asc: 0,
      //   field: 'recommendDate'
      // }).then(res => {
      //   if (res.code === 2000) {
      //     res.items.data.forEach(value => {
      //       value.image = getShowPath('img', value.image)
      //     })
      //     this.eventCards[1].list = res.items.data
      //   }
      // })

      api.topicList({
        asc: 0,
        field: 'publishTime',
        status: 1,
        rangeQuery: 1,
        page: 1,
        limit: 4
      }).then(r => {
        if (r.code === 2000) {
          r.items.data.forEach(v => {
            v.coverImage = getShowPath('img', v.coverImage)
          })
          this.topicCards = r.items.data
          this.topicCount = r.items.totalCount
        }
      })
    },
    slidesPerViewNum() {
      if (window.innerWidth < 1000) {
        return 3
      } else if (window.innerWidth >= 1000 && window.innerWidth < 1400) {
        return 4
      } else if (window.innerWidth >= 1400) {
        return 5
      }
    },
    menuTap(val) {
      this.currIndex = val
      this.verwiper.slideTo(val)
    },
    initHorizontalSwiper() {
      // const that = this
      this.horwiper = new Swiper('.swiper-slide-wraper-horizontal', {
        speed: 2000,
        modules: [Scrollbar, FreeMode],
        slidesPerView: this.slidesPerViewNum(),
        spaceBetween: 20,
        centeredSlides: false,
        watchSlidesProgress: true,
        grabCursor: false,
        autoplay: true,
        freeMode: {
          enabled: true
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          dragSize: 30,
          hide: false,
          draggable: true
        }
      })
      // this.horwiper.on('slideChange', () => {
      //   const swiperItemIndex = parseInt(this.swiperItemTotal * this.horwiper.progress / this.swiperItemWidth)
      //   this.swiperItemYear = this.swiperList[swiperItemIndex].startDate
      // })
      this.horwiper.on('progress', (sw, pro) => {
        const swiperItemIndex = parseInt(this.swiperItemTotal * pro / (this.swiperItemWidth + 20))
        if (swiperItemIndex >= this.swiperList.length) { return }
        this.swiperItemYear = this.swiperList[swiperItemIndex].startDate
      })
    },
    /**
     * 重置轨迹
     */
    resetTrack() {
      this.pauseTrack()
      // 1. 重置所有状态
      this.activeIndex = -1
      this.currentStep = 0
      this.currentFrame = 0
      this.dynamicPath = []

      // 2. 清除所有标记和轨迹
      if (this.animateMarker) this.animateMarker.setMap(null)
      if (this.dynamicPolyline) this.dynamicPolyline.setMap(null)
      this.markers.forEach(marker => marker.setMap(null))

      // 3. 回到地图起点
      // eslint-disable-next-line no-undef
      if (this.map && qq && qq.maps) {
        // eslint-disable-next-line no-undef
        this.map.panTo(new qq.maps.LatLng(
          this.locationList[0].lat,
          this.locationList[0].lng
        ))
      }
    },
    /**
     * 暂停轨迹播放
     */
    pauseTrack() {
      this.isPlaying = false
      if (this.animateTimer) {
        clearInterval(this.animateTimer)
        this.animateTimer = null
      }
    },
    changeMap(index) {
      this.pauseTrack()
      this.activeIndex = index
      if (this.dynamicPolyline) {
        this.dynamicPolyline.setMap(null)
        this.dynamicPolyline = null // 销毁轨迹线实例
      }
      this.dynamicPath = [] // 清空轨迹路径

      // 3. 清除移动标记
      if (this.animateMarker) {
        this.animateMarker.setMap(null)
        this.animateMarker = null // 销毁移动标记实例
      }

      // 1. 清除所有已显示的标记
      this.markers.forEach(marker => {
        if (marker.getMap() !== null) {
          marker.setMap(null)
        }
      })

      // 2. 显示当前点击的标记
      const currentMarker = this.markers[index]
      currentMarker.setMap(this.map)

      // 3. 定位到该点
      // eslint-disable-next-line no-undef
      this.map.panTo(new qq.maps.LatLng(
        this.pointCards[index].mapPlace[1],
        this.pointCards[index].mapPlace[0]
      ))

      this.map.setZoom(9) // 放大至10级
      this.activeIndex = index
    },
    loadMap() {
      this.createMapInstance()
    },
    createMapInstance() {
      // eslint-disable-next-line no-undef
      this.map = new qq.maps.Map(document.getElementById('amap-body'), {
        // eslint-disable-next-line no-undef
        center: new qq.maps.LatLng(this.pointCards[0].mapPlace[1], this.pointCards[0].mapPlace[0]),
        zoom: this.defaultZoom, // 初始缩放级别
        // eslint-disable-next-line no-undef
        disableDefaultUI: false,
        mapStyleId: 'style2',
        mapTypeControl: false,
        zoomControl: false,
        streetViewControl: false,
        styles: [{
          'featureType': 'road',
          'elementType': 'all',
          'stylers': [{
            'visibility': 'off'
          }]
        }, {
          'featureType': 'traffic',
          'elementType': 'all',
          'stylers': [{
            'visibility': 'off'
          }]
        }, {
          'featureType': 'highway',
          'elementType': 'all',
          'stylers': [{
            'visibility': 'off'
          }]
        }, {
          'featureType': 'arterial',
          'elementType': 'all',
          'stylers': [{
            'visibility': 'off'
          }]
        }, {
          'featureType': 'transit',
          'elementType': 'all',
          'stylers': [{
            'visibility': 'off'
          }]
        }]
      })
      this.initMarkers()
      this.changeMap(0)
    },

    /**
     * 播放轨迹动画
     */
    playTrack() {
      // eslint-disable-next-line no-undef
      if (this.isPlaying || !this.map || !qq || !qq.maps) return

      this.isPlaying = true
      this.currentStep = 0 // 从第0个地点开始
      this.currentFrame = 0 // 初始帧
      this.activeIndex = 0 // 高亮起点
      this.dynamicPath = [] // 清空动态路径

      // 恢复初始缩放级别
      this.map.setZoom(4)

      if (this.dynamicPolyline) this.dynamicPolyline.setMap(null)
      if (this.animateMarker) this.animateMarker.setMap(null)
      this.markers.forEach(marker => marker.setMap(null))

      // 2. 仅显示起点标记

      // 1. 获取第一个地点坐标（动画起始点）
      const startPoint = this.pointCards[0]
      // eslint-disable-next-line no-undef
      const startLatLng = new qq.maps.LatLng(startPoint.mapPlace[1], startPoint.mapPlace[0])

      // 2. 缩放到动画级别（zoom=4），并定位到第一个地点（修正核心）
      this.map.setZoom(4)
      this.map.setCenter(startLatLng) // 强制设置中心为第一个地点

      // 3. 初始化动态轨迹线（空路径）
      // eslint-disable-next-line no-undef
      this.dynamicPolyline = new qq.maps.Polyline({
        path: this.dynamicPath,
        strokeColor: '#FFF7AA',
        strokeWeight: 2,
        strokeOpacity: 0.4,
        map: this.map
      })

      // eslint-disable-next-line no-undef
      this.dynamicPath = [new qq.maps.LatLng(
        this.pointCards[0].mapPlace[1],
        this.pointCards[0].mapPlace[0]
      )] // 初始化动态路径

      this.dynamicPolyline.setPath(this.dynamicPath)

      // 开始动画
      this.startAnimate()
    },

    /**
     * 轨迹动画核心逻辑
     */
    startAnimate() {
      // eslint-disable-next-line no-undef
      if (!this.isPlaying || !qq || !qq.maps) {
        this.isPlaying = false
        return
      }

      // 播放完成
      if (this.currentStep >= this.pointCards.length - 1) {
        this.isPlaying = false
        return
      }

      const startPoint = this.pointCards[this.currentStep].mapPlace
      const endPoint = this.pointCards[this.currentStep + 1].mapPlace
      // 核心：需求2 - 动态计算stepCount（根据距离）
      const stepCount = this.getDynamicStepCount(
        startPoint[1],
        startPoint[0],
        endPoint[1],
        endPoint[0]
      )
      // 根据速度调整步进数（速度越慢，步进数越多，越平滑）
      const stepLat = (endPoint[1] - startPoint[1]) / stepCount
      const stepLng = (endPoint[0] - startPoint[0]) / stepCount
      this.animateTimer = setInterval(() => {
        // 1. 帧计数+1
        this.currentFrame++

        // 2. 计算当前帧的位置
        const currentLat = startPoint[1] + stepLat * this.currentFrame
        const currentLng = startPoint[0] + stepLng * this.currentFrame
        // eslint-disable-next-line no-undef
        const currentPos = new qq.maps.LatLng(currentLat, currentLng)

        // 1. 更新移动标记位置
        // this.animateMarker.setPosition(currentPos)

        // 核心：需求1 - 镜头跟随动画移动
        this.map.panTo(currentPos)

        // 4. 更新动态轨迹线（添加当前帧位置）
        this.dynamicPath.push(currentPos)
        this.dynamicPolyline.setPath(this.dynamicPath)

        // 3. 到达终点
        if (this.currentFrame >= stepCount) {
          clearInterval(this.animateTimer)
          this.currentStep++
          console.log('currentStep', this.currentStep)
          // 5.1 显示当前到达的地点标记
          // try {
          //   const arriveMarker = this.markers[this.currentStep + 1]
          //   arriveMarker.setMap(this.map)
          // } catch (error) {
          //   console.log('error', error)
          // }

          this.activeIndex = this.currentStep
          this.currentFrame = 0 // 重置帧计数
          this.activeIndex = this.currentStep // 高亮当前到达的点

          // 定位到当前点
          // eslint-disable-next-line no-undef
          this.map.panTo(new qq.maps.LatLng(endPoint[1], endPoint[0]))

          // 继续下一段动画
          this.startAnimate()
        }
      }, this.animateSpeed)
    },

    /**
     * 计算两点之间的距离（米）
     */
    calculateDistance(lat1, lng1, lat2, lng2) {
      const R = 6371000 // 地球半径（米）
      const radLat1 = Math.PI * lat1 / 180
      const radLat2 = Math.PI * lat2 / 180
      const deltaLat = Math.PI * (lat2 - lat1) / 180
      const deltaLng = Math.PI * (lng2 - lng1) / 180

      // 哈弗辛公式
      const a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
                Math.cos(radLat1) * Math.cos(radLat2) *
                Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2)
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      return R * c // 距离（米）
    },

    /**
     * 根据距离计算动态stepCount（保证视觉速度一致）
     */
    getDynamicStepCount(startLat, startLng, endLat, endLng) {
      console.log('startLat', startLat)
      console.log('startLng', startLng)
      console.log('endLat', endLat)
      console.log('endLng', endLng)
      // eslint-disable-next-line no-undef
      if (!this.map || !qq) return 50

      // 1. 计算实际距离（米）
      const distance = this.calculateDistance(startLat, startLng, endLat, endLng)

      // 2. 将距离转换为地图像素（根据当前缩放级别）
      const startPoint = this.map.getProjection().fromLatLngToPoint(
        // eslint-disable-next-line no-undef
        new qq.maps.LatLng(startLat, startLng)
      )
      const endPoint = this.map.getProjection().fromLatLngToPoint(
        // eslint-disable-next-line no-undef
        new qq.maps.LatLng(endLat, endLng)
      )
      const pixelDistance = Math.sqrt(
        Math.pow(endPoint.x - startPoint.x, 2) +
        Math.pow(endPoint.y - startPoint.y, 2)
      )

      // 3. 根据基础步速计算stepCount（保证视觉速度一致）
      const stepCount = Math.max(Math.round(pixelDistance / this.baseStepSpeed), 10)
      console.log(`两点距离：${distance.toFixed(2)}米，像素距离：${pixelDistance.toFixed(2)}，stepCount：${stepCount}`)
      return stepCount
    },

    initMarkers() {
      this.pointCards.forEach((item, index) => {
        // eslint-disable-next-line no-undef
        const marker = new qq.maps.Marker({
          // eslint-disable-next-line no-undef
          position: new qq.maps.LatLng(item.mapPlace[1], item.mapPlace[0]),
          map: null, // 初始不显示
          title: item.name,
          label: {
            content: `${index + 1}`,
            color: '#fff',
            fontSize: '12px'
          }
        })
        // eslint-disable-next-line no-undef
        qq.maps.event.addListener(marker, 'click', () => {
          // 存储当前标记的所有数据信息
          const markerData = {
            index: index, // 标记索引
            data: { ...item } // 标记原始数据（深拷贝）
          }
          // 4. 可选：执行其他业务逻辑
          this.handleMarkerClick(markerData)
        })
        this.markers.push(marker)
      })
    },

    handleMarkerClick(v) {
      const page = this.$router.resolve({
        path: '/entity',
        query: {
          cateId: '013004',
          sourceId: v.data.id
        }
      })
      window.open(page.href, '_blank')
    },
    showLocation() {
      const allOverlays = this.maps.getOverlays()// 返回地图上所有的覆盖物
      // 循环找到数组里面id和返回覆盖物相同的
      for (let i = 0; i < allOverlays.length; i++) {
        this.maps.removeOverlay(allOverlays[i])
      }
      const value = this.pointCards[this.mapIndex].mapPlace
      // eslint-disable-next-line
      var marker1 = new BMapGL.Marker(new BMapGL.Point(value[0], value[1]));
      // eslint-disable-next-line
      this.maps.centerAndZoom(new BMapGL.Point(value[0], value[1]), 6)
      this.maps.addOverlay(marker1)
      const that = this
      marker1.addEventListener('click', function() {
        const page = that.$router.resolve({
          path: '/entity',
          query: {
            cateId: '013004',
            sourceId: that.pointCards[that.mapIndex].id
          }
        })
        window.open(page.href, '_blank')
      })
    },
    inputChange(e) {
      this.$router.push({
        path: '/search',
        query: { key: this.searchKey }
      })
    },
    toSource(val) {
      const { code } = this.sourceCards[val]
      const page = this.$router.resolve({
        path: '/source',
        query: {
          cateId: code
        }
      })
      window.open(page.href, '_blank')
    },
    toEvent(val) {
      const { code } = this.eventCards[val]
      const page = this.$router.resolve({
        path: '/entity',
        query: {
          cateId: code
        }
      })
      window.open(page.href, '_blank')
    },

    toRecEntity(val, ev) {
      const { code } = val
      const page = this.$router.resolve({
        path: '/entity',
        query: {
          cateId: code,
          sourceId: ev.id
        }
      })
      window.open(page.href, '_blank')
    },
    toBannerEvent(val) {
      const { id } = this.swiperList[val]
      const page = this.$router.resolve({
        path: '/entity',
        query: {
          cateId: '013003',
          sourceId: id
        }
      })
      window.open(page.href, '_blank')
    },
    totalSearch() {
      if (this.searchKey) {
        this.$router.push({
          path: '/search',
          query: { key: this.searchKey }
        })
        this.searchKey = ''
      } else {
        this.searchKey = ''
        this.showSearch = true
        const that = this
        setTimeout(() => {
          that.$refs.saveTagInput.focus()
        }, 500)
      }
    },
    toRelation(val) {
      const page = this.$router.resolve({
        path: '/relation',
        query: {
          id: val.count
        }
      })
      window.open(page.href, '_blank')
    },
    toTopic(val) {
      console.error(val)
      if (val.id) {
        const page = this.$router.resolve({
          path: '/topic/info',
          query: {
            id: val.id
          }
        })
        window.open(page.href, '_blank')
      } else {
        const page = this.$router.resolve({
          path: '/topic'
        })
        window.open(page.href, '_blank')
      }
    }
  }
}
</script>

<style scoped>
  .swiper {
    width: 100%;
    min-width: 1220px;
  }

  .swiper-slide {
    height: auto;
  }

  .swiper-topnav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    padding: 24px 20px 26px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
  }

  .swiper-topnav-logo {
    height: 50px;
    left: 20px;
  }

  .swiper-topnav-btn {
    right: 20px;
  }

  .swiper-topnav-btn-input {
    width: 300px;
    height: 36px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    padding-right: 9px;
    transition: 0.4s;
    position: absolute;
    right: 0;
    z-index: -1;
  }

  .swiper-topnav-btn-input.show {
    opacity: 1;
  }

  .swiper-topnav-btn-input.hide {
    opacity: 0;
  }

  .swiper-topnav-btn-input input {
    height: 34px;
    outline: none;
    border: none;
    flex: 1;
  }

  .swiper-topnav-btn-input img {
    flex-shrink: 0;
    width: 18px;
    margin-left: 4px;
  }

  .swiper-topnav div img {
    margin-left: 10px;
  }

  .swiper-topnav-text p {
    line-height: 25px;
    color: rgba(255, 255, 255, 0.6);
    margin-right: 25px;
    transition: 0.8s;
  }

  .swiper-topnav-text p:hover {
    color: #fff;
    transition: 800ms;
  }

  .swiper-topnav-text p.active {
    color: #fff;
    transition: 500ms;
  }

  .swiper-topnav-text p:last-child {
    margin: 0;
  }

  .swiper-slide-wraper {
    height: 100%;
  }

  .swiper-slide.last {
    height: 200px !important;
  }

  .swiper-slide-wraper.p1 {
    background-image: url('../../assets/shjk/icon-web-home-01.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .swiper-slide-wraper.p1 {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .swiper-slide-wraper.p2 {
    background-image: url('../../assets/shjk/icon-web-home-02.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    /* padding-top: 130px; */
  }

  .swiper-slide-wraper.p3 {
    background-image: url('../../assets/shjk/icon-web-home-03.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    /* padding-top: 130px; */
  }

  .swiper-slide-wraper.p4 {
    background-image: url('../../assets/shjk/icon-web-home-04.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .swiper-slide-wraper.p5 {
    background-image: url('../../assets/shjk/icon-web-home-05.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .swiper-slide-wraper.p6 {
    background-image: url('../../assets/shjk/icon-web-home-06.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .swiper-slide-wraper.p1 .match-width {
    justify-content: center;
  }

  .swiper-slide-wraper-horizontal {
    margin-top: 20px;
  }

  .swiper-slide-wraper-horizontal .swiper-wrapper {
    transition-timing-function: linear!important;
  }

  .swiper-slide-wraper-horizontal .swiper-slide {
    width: 260px;
    height: 440px !important;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(10px);
    margin-right: 20px;
    padding: 30px 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }

  .swiper-slide-wraper-horizontal .swiper-slide:hover {
    transition: 200ms;
    box-shadow: 0px 20px 15px 0px rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(20px);
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
  }

  .swiper-slide-wraper-horizontal .swiper-slide .date {
    height: 26px;
    display: inline-block;
    padding: 0 8px;
    line-height: 26px;
    background: #B20000;
    color: #fff;
    font-size: 12px;
    margin-bottom: 10px;
    border-radius: 3px;
    opacity: 1;
  }

  .swiper-slide-wraper-horizontal .swiper-slide .date.active {
    opacity: 1;
  }

  .swiper-slide-wraper-horizontal .swiper-slide .tit {
    line-height: 20px;
    color: #1A1A1A;
    font-size: 16px;
    margin-bottom: 10px;
  }

  .swiper-slide-wraper-horizontal .swiper-slide img {
    width: 100%;
    max-height: 260px;
    object-fit: cover;
    margin-bottom: 10px;
    border-radius: 5px;
  }

  .swiper-slide-wraper-horizontal .swiper-slide .des {
    line-height: 18px;
    color: rgba(0, 0, 0, 0.5);
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .swiper-slide-wraper-layer {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 100px;
  }

  .swiper-slide-wraper-layer-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    border-radius: 5px;
    background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.8) 100%);
    backdrop-filter: blur(20px);
    height: 510px;
    padding: 20px 20px 40px;
    margin-right: 20px;
    transition: 0.5s;
  }

  .swiper-slide-wraper-layer-item:last-child {
    margin-right: 0;
  }

  .swiper-slide-wraper-layer-item .top .img {
    height: 200px;
  }

  .swiper-slide-wraper-layer-item .top img {
    margin: 0 auto;
  }

  .swiper-slide-wraper-layer-item .top .tit {
    line-height: 40px;
    text-align: center;
    font-size: 30px;
    color: #B20000;
    margin-top: -44px;
    margin-bottom: 20px;
  }

  .swiper-slide-wraper-layer-item .top .desc {
    color: #1A1A1A;
    line-height: 25px;
    text-align: center;
    font-size: 14px;
  }

  .swiper-slide-wraper-layer-item .tail {
    padding: 0 20px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    height: 40px;
  }

  .swiper-slide-wraper-layer-item .tail p {
    color: rgba(0, 0, 0, 0.6);
    font-size: 12px;
  }

  .swiper-slide-wraper-layer-item:hover .tail {
    background: #B20000;
    border: none;
  }

  .swiper-slide-wraper-layer-item:hover .tail p {
    color: #fff;
  }

  .swiper-slide-wraper-layer-item:hover {
    /* animation: slide-up .5s ease-in-out forwards; */
    transform: translateY(-5px);
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
  }

  /* .swiper-slide-wraper-layer-item.in {
    animation: slide-up .5s ease-in-out forwards;
  }

  .swiper-slide-wraper-layer-item.out {
    animation: slide-down .5s ease-in-out forwards;
  } */

  @keyframes slide-down {
    from {
      margin-top: -20px;
    }
    to {
      margin-top: 0;
      background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.8) 100%);
    }
  }

  @keyframes slide-up {
    from {
      margin-top: 0px;
    }
    to {
      margin-top: -20px;
      background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
    }
  }

  .p3 .swiper-slide-wraper-layer{
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(204, 177, 122, 0.6) 0%, rgba(204, 177, 122, 0.9) 100%);
    backdrop-filter: blur(30px);
    padding: 0 100px;
  }

  .swiper-slide-wraper-layer-list {
    width: 100%;
  }

  .swiper-slide-wraper-layer-list:last-child {
    margin-top: 20px;
  }

  .swiper-slide-wraper-layer-list-item {
    flex: 1;
    margin-right: 20px;
    border-radius: 5px;
    height: 250px;
    overflow: hidden;
    position: relative;
    padding-left: 100px;
    transition: 0.5s;
  }

  .swiper-slide-wraper-layer-list-item:hover {
    transform: scale(.98);
  }

  .swiper-slide-wraper-layer-list-item:last-child {
    margin-right: 0;
  }

  .swiper-slide-wraper-layer-list-item img{
    position: absolute;
    height: 250px;
    z-index: -1;
    object-fit: cover;
    top: 0;
    left: 0;
  }

  .swiper-slide-wraper-layer-list-item-layer {
    background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.75) 100%);
    height: 250px;
    padding-right: 30px;
  }

  .swiper-slide-wraper-layer-list-item-layer {
    align-items: flex-end;
    justify-content: center;
  }

  .swiper-slide-wraper-layer-list-item-layer .top  {
    align-items: flex-end;
  }

  .swiper-slide-wraper-layer-list-item-layer .top p {
    color: #fff;
    font-size: 12px;
    font-weight: 400;
    line-height: 40px;
  }

  .swiper-slide-wraper-layer-list-item-layer .top .count {
    font-size: 30px;
    line-height: 50px;
    margin-right: 4px;
  }

  .swiper-slide-wraper-layer-list-item-layer .tit {
    line-height: 50px;
  }

  .p4 .swiper-slide-wraper-layer {
    background: rgba(221, 221, 221, 0.8);
    backdrop-filter: blur(25px);
  }

  .swiper-slide-wraper-layer-p4list-item {
    flex: 1;
    height: 510px;
    border-radius: 5px;
    margin-right: 20px;
    position: relative;
    overflow: hidden;
    transition: 0.5s;
    background-color: #fff;
  }

  .swiper-slide-wraper-layer-p4list-item .top {
    width: 100%;
    height: 170px;
    padding: 40px 20px 0;
    position: relative;
    margin-bottom: 10px;
    /* display: flex;
    flex-direction: column;
    justify-content: flex-end; */
  }

  .swiper-slide-wraper-layer-p4list-item .top .img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }

  .swiper-slide-wraper-layer-p4list-item .top .tit {
    position: relative;
    line-height: 60px;
    font-size: 30px;
    color: #FFFFFF;
    z-index: 2;
  }

  .swiper-slide-wraper-layer-p4list-item .top .info {
    line-height: 25px;
    font-size: 14px;
    color: #FFFFFF;
    position: relative;
    z-index: 2;
  }

  .swiper-slide-wraper-layer-p4list-item .list {
    height: 300px;
    margin-bottom: 10px;
  }

  .swiper-slide-wraper-layer-p4list-item .list .item {
    height: 60px;
    padding: 0 20px;
  }

  .swiper-slide-wraper-layer-p4list-item .list .item:hover {
    background: #f7f7f7;
  }

  .swiper-slide-wraper-layer-p4list-item .list .item .icon {
    width: 40px;
    height: 40px;
    border-radius: 5px;
    margin-right: 10px;
  }

  .swiper-slide-wraper-layer-p4list-item .list .item .name {
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
    color: #1A1A1A;
  }

  .swiper-slide-wraper-layer-p4list-item .list .item .des {
    font-size: 12px;
    line-height: 20px;
    font-weight: bold;
    color: #767676;
  }

  .swiper-slide-wraper-layer-p4list-item .tail {
    color: #999;
    font-size: 14px;
    border-top: 1px solid #eee;
    height: 20px;
    line-height: 14px;
    text-align: center;
  }

  .swiper-slide-wraper-layer-p4list-item:last-child {
    margin-right: 0;
  }

  .swiper-slide-wraper-layer-p4list-item:hover {
    transform: scale(1.02);
  }

  .p5 .swiper-slide-wraper-layer {
    background: linear-gradient(180deg, rgba(153, 128, 77, 0.6) 0%, rgba(153, 128, 77, 0.98) 100%);
    backdrop-filter: blur(30px);
  }

  .swiper-slide-wraper-layer-p5list-item {
    flex: 1;
    height: 520px;
    max-width: 395px;
    border-radius: 5px;
    margin-right: 20px;
    position: relative;
    overflow: hidden;
    transition: 0.5s;
    flex-shrink: 0;
  }

  .swiper-slide-wraper-layer-p5list-item:hover {
    transform: scale(1.02);
  }

  .swiper-slide-wraper-layer-p5list-item .img{
    height: 520px;
    width: 100%;
  }

  .swiper-slide-wraper-layer-p5list-item .tit {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    background: linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
    height: 40px;
    padding: 0 20px;
  }

  .swiper-slide-wraper-layer-p5list-item .tit p {
    line-height: 40px;
    font-size: 14px;
    color: #fff
  }

  .p6 .swiper-slide-wraper-layer {
    background: rgba(128, 0, 0, 0.75);
  }

  .swiper-slide-wraper-layer-content {
    height: calc(100% - 320px);
    width: 100%;
    margin-top: -100px;
  }

  .swiper-slide-wraper-layer-content-list {
    width: 32%;
    margin-left: 20px;
    background: rgba(0, 0, 0, 0.2);
    height: 100%;
    border-radius: 5px;
    padding: 10px 20px;
    overflow-y: scroll;
  }

  .swiper-slide-wraper-layer-content-list-item img {
    width: 14px;
  }

  .swiper-slide-wraper-layer-content-list-item .icon {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.5);
    line-height: 40px;
    width: 14px;
    text-align: center;
  }

  .swiper-slide-wraper-layer-content-list-item .tit {
    font-size: 14px;
    line-height: 40px;
    color: #FFFFFF;
    margin-left: 10px;
  }

  .swiper-slide-wraper-layer-content-list-item .date {
    color: rgba(255, 255, 255, 0.5);
    line-height: 40px;
    font-size: 14px;
    width: 100px;
    text-align: right;
  }

  .swiper-slide-wraper-layer-content-map {
    width: 66%;
    border-radius: 5px;
    height: 100%;
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.2);
  }

  .swiper-scrollbar{
    bottom: 40px !important;
}

.swiper-scrollbar-drag{
    width:50px !important;
    background: url(../../assets/shjk/bgWave.png) no-repeat !important;
    background-size: 100% 100% !important;
    height: 50px !important;
    top: -50px !important;
}

.swiper-scrollbar-drag span {
  display: inline-block;
  height: 50px;
  width: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 14px;
  color: #FFDD99;
  border-radius: 25px;
  position: relative;
  bottom: 0px;
  right:0px;
  pointer-events: none;
}

.nav-bottom {
  position: absolute!important;;
  bottom: 0;
  left: 0;
  right: 0;
}

.show-more {
  flex-shrink: 0;
  width: 60px;
  height: 520px;
  margin-left: 20px;
  background: rgba(0, 0, 0, 0.25);
}
.show-more  p {
  letter-spacing: 12px;
  line-height: 32px;
  text-align: center;
  margin-left: 8px;
}
</style>

<style lang="scss" scoped>

  /deep/.el-input__inner {
    padding: 0 10px;
    color: #fff;
    font-size: 12px;
    border: none;
    height: 34px;
    background-color: rgba($color: #fff, $alpha: 0);
  }

</style>

<style lang="scss" scoped>
.swiper-slide-wraper-layer-content-list::-webkit-scrollbar {
 width: 6px;
}

.swiper-slide-wraper-layer-content-list::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.4);

 &:hover {
  background: rgba(255, 255, 255, 0.4);
 }

 &:active {
  background: rgba(255, 255, 255, 0.4);
 }
}

.swiper-slide-wraper-layer-content-list {
 scrollbar-width: thin;
 scrollbar-color: rgba(255, 255, 255, 0.4) rgba(255, 255, 255, 0.4);
}
</style>
